/* global angular */

var ngModule = angular.module('trends');

/* Wraps a promise and tracks its progress. */
ngModule.factory('Monitor', [
    function () {
        function Monitor() {
            this.promise = null;
            this.canceller = null;
            this.resolved = false;
        }

        /* Start tracking a new promise. If a promise was already being watched,
           it is cancelled (if possible) and no longer tracked. */
        Monitor.prototype.watch = function (promise, canceller) {
            if (promise && this.promise === promise) {
                throw new Error('Promise is already tracked');
            }

            this.cancel();

            var that = this;
            this.resolved = false;
            this.promise = promise;
            this.canceller = canceller || null;

            if (promise) {
                this.promise['finally'](function () {
                    // If we're still monitoring the promise
                    // then we're resolved
                    if (that.promise === promise) {
                        that.resolved = true;
                    }
                });
            }
            return promise;
        };

        Monitor.prototype.reset = function () {
            this.watch(null);
        };

        Monitor.prototype.cancel = function () {
            if (this.canceller) {
                this.canceller.resolve();
            }
        };

        Monitor.prototype.isBusy = function () {
            return this.promise !== null && !this.resolved;
        };

        return Monitor;
    }]);
